import { useCallback, useMemo } from "react"
import { useSearchParams } from "react-router-dom"
import _ from "lodash"
import { useVenue } from "providers/venue"
import { Q_VENUE } from "../constant"

type FilterByVenueId = (venueId: string) => void

interface IUseServiceResult {
  filteredServiceByVenue: IFilteredServiceByVenue[]
}

interface IService {
  id: string
  image: string
  location: {
    id: string
  }
  name: {
    en: string
  }
}

interface IFilteredServiceByVenue extends IService {
  venue_id: string
  level_name: string
}

type UseService = (
  service: IService[],
  venueFilter?: string
) => IUseServiceResult

export const useService: UseService = (service, venueFilter) => {
  const [, setSearchParams] = useSearchParams()
  const { findFeatureById } = useVenue()

  const filterByVenueId: FilterByVenueId = useCallback(
    (venueId) => {
      if (venueId) setSearchParams({ [Q_VENUE]: venueId }, { replace: true })
    },
    [setSearchParams]
  )

  const preparedService = useMemo(
    () =>
      _.map(service, (location) => {
        const featureId = _.get(location, "location.id")
        const levelName = _.get(
          findFeatureById(featureId),
          "properties.level_name"
        )
        const venueId = _.get(findFeatureById(featureId), "properties.venue_id")
        return { ...location, level_name: levelName, venue_id: venueId }
      }),
    [service, findFeatureById]
  )

  const filteredServiceByVenue = useMemo(
    () => preparedService.filter(({ venue_id }) => venueFilter === venue_id),
    [preparedService, venueFilter]
  )

  return {
    filterByVenueId,
    filteredServiceByVenue,
  }
}
